module.exports = __webpack_public_path__ + "img/verified-black-24-dp.6a70626e.svg";